import { render, staticRenderFns } from "./ImageStandard.vue?vue&type=template&id=49915fa1&"
import script from "./ImageStandard.vue?vue&type=script&lang=ts&"
export * from "./ImageStandard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports